var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({height:'100%'})},[_c('vue-header',{attrs:{"title":"面诊","isReturn":"true"}}),_c('camera',{attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }